export default __webpack_public_path__ + "static/media/n6.53b935ed.svg";